import * as CompanyActions from 'app/core/store/actions/noms/company.actions';
import { initialState } from '../../states/noms/company.states';


export type Action = CompanyActions.All

export function reducer(state = initialState, action: Action) {
    switch (action.type) {
        case CompanyActions.GET_LIST_OPTIONS_SUCCESS : {
            return {
                ...state,
                listOptions: action.payload
            }
        }

        default: return state
    }
}
